import Vue from "vue";

Vue.component("wto-multi-select", {
    props: ["label", "placeholder", "items", "ids", "isReadOnly", "error", "required", "onBorder", "reference", "list", "showHelpIcon", "urlRedirection", "helpIconTitle", "showDisclaimerIcon", "disclaimerTooltip"],
    data() {
        return {
            options: [],
            selectedIds: [],
            selectedList: [],
            showSelector: false,
            anchorRef: 'anchor' + this.reference,
            inputRef: 'input' + this.reference,
            names: ""
        }
    },
    methods: {
        onFocusOut: function () {
            this.showSelector = false;
        },
        getTextValue: function (ids, options) {
            let returnValue = '';
            if (ids && ids.length > 0) {
                returnValue = "";
                ids.forEach(function (id) {
                    const items = options.filter(function (item) {
                        return item.value === id;
                    });
                    if (items && items.length > 0) returnValue += items[0].text + '; ';
                });
                returnValue = returnValue.substr(0, returnValue.length - 2);
            }
            this.names = returnValue;
        },
        triggerSelector: function () {
            this.showSelector = !this.showSelector;
            this.$refs[this.inputRef].$refs.taginput.focus();
        },
        onDataChange: function () {
            this.$emit('on-data-change');
        },
        showHelpModal: function () {
            this.$emit('on-show-help-modal');
        },
    },
    computed: {
        computedValue: {
            get() {
                const ids = this.ids;
                if (!ids || ids.length === 0) return [];
                const returnIds = [];
                ids.forEach(function (id) {
                    returnIds.push(id.toString());
                });
                this.getTextValue(returnIds, this.items);
                return returnIds;
            },
            set(value) {
                this.getTextValue(value, this.items);
                this.$emit("update:ids", value);
            }
        },
        labelClass() {
            let returnValue = 'label';

            if (this.required) returnValue += ' required-field';
            if (this.onBorder) returnValue += ' on-border';

            return returnValue;
        },
        iconUrlLink() {
            let returnValue = 'javascript:void(0)';

            if (this.urlRedirection) {
                returnValue = this.urlRedirection;
            }

            return returnValue;
        }
    },
    mounted() {
        this.options = this.items;
    },
    watch: {
        items: function (val) {
            this.options = val;
        },
        selectedList: function (val) {
            this.$emit("update:list", val);
        }
    },
    template: `
      <div class="control-container">
        <span v-if="!showDisclaimerIcon" :class="labelClass">
            {{ label }}
            <a v-if="showHelpIcon" style="text-decoration: none" :title="helpIconTitle" :href="iconUrlLink" @click="showHelpModal">
                <b-icon pack="far" icon="info-circle" size="is-small"></b-icon>
            </a>
        </span>
        <div v-if="showDisclaimerIcon" style="display: flex; align-items: center; gap: 2px">     
          <span :class="labelClass">{{ label }}</span>
          <b-tooltip class="search-product-free-text" style="margin-bottom: 3px" :label="disclaimerTooltip" type="is-primary is-light" position="is-right" size="is-large" multilined>
            <b-icon pack="far" icon="book-open" size="is-small"></b-icon>
          </b-tooltip>
        </div>
        <b-field :type="error ? 'is-danger' : ''" :message="error">
          <a v-if="!isReadOnly" :ref="anchorRef" class="button control-collapse" @click="triggerSelector">
            <div contentEditable=true oncut="return false" onpaste="return false" onkeydown="if(event.metaKey) return true; return false;" :data-text="placeholder"
                 class="truncate-overflow content-text" :title="names">{{ names }}
            </div>
            <b-icon icon="chevron-down" pack="fas" type="is-primary"></b-icon>
          </a>
          <a v-else :ref="anchorRef" class="button control-collapse">
            <div contentEditable=true oncut="return false" onpaste="return false" onkeydown="if(event.metaKey) return true; return false;" :data-text="placeholder"
                 class="truncate-overflow content-text" :title="names">
              {{ names }}
            </div>
          </a>
        </b-field>
        <div class="multi-select-control" v-show="showSelector" v-closable="{exclude: [anchorRef], handler: 'onFocusOut'}">
          <wto-tag-input-ids @on-data-change="onDataChange" :ref="inputRef" :placeholder="placeholder" :items="items" :ids.sync="computedValue" :list.sync="selectedList"></wto-tag-input-ids>
        </div>
      </div>
    `
});